export type RewardCategory = "avatar" | "title" | "theme";

export interface RewardItem {
  id: string;
  category: RewardCategory;
  emoji: string;
  name: string;
  cost: number;
  desc: string;
}

export const REWARD_ITEMS: RewardItem[] = [
  // ── Avatars (replace the 🦸 on the Progress hero) ────────────────────────
  { id: "avatar_moneybag",  category: "avatar", emoji: "🤑", name: "Money Face",    cost: 50,  desc: "For the true coin lover" },
  { id: "avatar_lion",      category: "avatar", emoji: "🦁", name: "Lion King",     cost: 75,  desc: "Rule the money jungle" },
  { id: "avatar_rocket",    category: "avatar", emoji: "🚀", name: "Rocket",        cost: 100, desc: "Your savings are launching" },
  { id: "avatar_unicorn",   category: "avatar", emoji: "🦄", name: "Unicorn",       cost: 150, desc: "Rare financial genius" },
  { id: "avatar_dragon",    category: "avatar", emoji: "🐲", name: "Money Dragon",  cost: 200, desc: "Hoard that gold!" },

  // ── Titles (shown in WorldMap hero under the heading) ─────────────────────
  { id: "title_collector",  category: "title",  emoji: "🪙", name: "Coin Collector",  cost: 50,  desc: "Always stacking coins" },
  { id: "title_saver",      category: "title",  emoji: "🐷", name: "Savings Star",    cost: 100, desc: "Future millionaire" },
  { id: "title_wizard",     category: "title",  emoji: "🧙", name: "Money Wizard",    cost: 150, desc: "You know the spells" },
  { id: "title_legend",     category: "title",  emoji: "👑", name: "Finance Legend",  cost: 300, desc: "The ultimate title" },

  // ── Themes (WorldMap hero gradient) ──────────────────────────────────────
  { id: "theme_ocean",      category: "theme",  emoji: "🌊", name: "Ocean Vibes",    cost: 100, desc: "Cool blue gradient" },
  { id: "theme_forest",     category: "theme",  emoji: "🌲", name: "Money Forest",   cost: 100, desc: "Lush green theme" },
  { id: "theme_sunset",     category: "theme",  emoji: "🌅", name: "Sunset Gold",    cost: 150, desc: "Warm golden tones" },
  { id: "theme_galaxy",     category: "theme",  emoji: "🌌", name: "Galaxy Brain",   cost: 200, desc: "Space money vibes" },
];

export const THEME_GRADIENTS: Record<string, string> = {
  default:       "linear-gradient(135deg,#fbbf24 0%,#f97316 50%,#ec4899 100%)",
  theme_ocean:   "linear-gradient(135deg,#0ea5e9 0%,#0284c7 50%,#0369a1 100%)",
  theme_forest:  "linear-gradient(135deg,#22c55e 0%,#16a34a 50%,#166534 100%)",
  theme_sunset:  "linear-gradient(135deg,#fbbf24 0%,#ef4444 50%,#dc2626 100%)",
  theme_galaxy:  "linear-gradient(135deg,#8b5cf6 0%,#7c3aed 50%,#312e81 100%)",
};

export const EMPTY_REWARDS = {
  coins: 0,
  xp: 0,
  unlockedItems: [] as string[],
  equipped: { avatar: null as string | null, title: null as string | null, theme: null as string | null },
};
